import { Controller } from "@hotwired/stimulus";
import { createApp } from "vue";
import { createPinia } from "pinia";
import App from "@xlayer/product/XApp.vue";
import { useProductBaseStore } from "@xlayer/store/productXBaseStore";

export default class extends Controller {
  static values = { 
    data: String,
    query: String,
    layout: String,
    url: String,
    componentUrls: String,
    dashboardId: String,
    download: Boolean,
  };

  app = null;

  connect() {
    window.addEventListener('scroll', this.handleScroll);
    const data = this.safeParseJSON(this.dataValue ?? "{}", {});
    const layout = this.safeParseJSON(this.layoutValue ?? "{}", {});
    this.initVueApp(data, layout, this.componentUrlsValue ?? "{}");
    const savedScrollData = this.safeParseJSON(localStorage.getItem('currentDashboardScroll') ?? "{}", null);

    if (savedScrollData && savedScrollData.dashboardId === this.dashboardIdValue) {
      setTimeout(() => {
        window.scrollTo({
          top: parseInt(savedScrollData.position, 10),
          behavior: 'smooth'
        });
        localStorage.removeItem('currentDashboardScroll');
      }, 150);
    }
  }

  handleScroll = () => {
    localStorage.setItem('currentDashboardScroll', JSON.stringify({
      dashboardId: this.dashboardIdValue,
      position: window.scrollY
    }));
  }

  disconnect() {

    if (this.app) {
      this.app.unmount();
      this.app = null;
    }

    if (window._Highcharts?.charts?.length) {
      window._Highcharts.charts.forEach((chart, index) => {
        if (chart) {
          if (chart.container) {
            chart.container.innerHTML = "";
          }
          chart.reflow();
        }
      });
    }

  }

  initVueApp(data, layout, componentUrls) {
    try {
      const app = createApp(App);
      const pinia = createPinia();
      app.use(pinia);

      const store = useProductBaseStore(pinia);
      const hasDownloadAttribute = this.element.hasAttribute('data-x-dashboard-download-value');
      const downloadValue = hasDownloadAttribute ? this.downloadValue : true;
      store.addInitialData(data, layout, componentUrls, downloadValue);

      app.mount(this.element);
      this.app = app;

      this.refreshHighcharts();

    } catch (error) {
      console.error("❌ Error initializing Vue app:", error);
    }
  }

  refreshHighcharts() {
    if (window._Highcharts?.charts?.length) {
      window._Highcharts.charts.forEach((chart, index) => {
        if (chart) {
          chart.reflow();
        }
      });
    }
  }

  safeParseJSON(value, fallback) {
    try {
      return JSON.parse(value);
    } catch (error) {
      console.error("❌ Failed to parse JSON:", value, error);
      return fallback;
    }
  }
}
